// DO NOT EDIT -- generated from fs/api/segment/behavior.proto

import { Event } from './event.proto';
import { Journey } from './journeymap.proto';
import { RetentionBehavior } from './retention.proto';

export interface Behavior {
  /** Leaf. */
  event?: Event | null;
  /** Behavior representing a specific journey. */
  journey?: Journey | null;
  /** Behavior representing a specific retention metric */
  retention?: RetentionBehavior | null;
}

export namespace Behavior {
  export enum behavior {
    /** Leaf. */
    event = 1,
    /** Behavior representing a specific journey. */
    journey = 2,
    /** Behavior representing a specific retention metric */
    retention = 3
  }

  /** Deprecated: use numeric constants instead of strings. */
  export enum behavior_keys {
    /** Leaf. */
    event = 'event',
    /** Behavior representing a specific journey. */
    journey = 'journey',
    /** Behavior representing a specific retention metric */
    retention = 'retention'
  }

  export function behavior_oneof(m: Behavior): { opt: behavior.event, key: behavior_keys.event, val: Event } | { opt: behavior.journey, key: behavior_keys.journey, val: Journey } | { opt: behavior.retention, key: behavior_keys.retention, val: RetentionBehavior } | null {
    if (m.event != null) { return { opt: behavior.event, key: behavior_keys.event, val: m.event } }
    if (m.journey != null) { return { opt: behavior.journey, key: behavior_keys.journey, val: m.journey } }
    if (m.retention != null) { return { opt: behavior.retention, key: behavior_keys.retention, val: m.retention } }
    return null;
  }
}
